var _rect, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWhyUs3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 74,
    viewBox: "0 0 75 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 74,
    height: 74,
    rx: 37,
    fill: "#B9CFE4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_327_1970)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.4334 14.2996C37.0099 13.9668 37.7203 13.9668 38.2968 14.2996L45.0402 18.193C45.6168 18.5258 45.9719 19.141 45.9719 19.8067V27.5934C45.9719 28.2591 45.6168 28.8743 45.0402 29.2071L38.2968 33.1005C37.7203 33.4333 37.0099 33.4333 36.4334 33.1005L29.69 29.2071C29.1134 28.8743 28.7582 28.2591 28.7582 27.5934V19.8067C28.7582 19.141 29.1134 18.5258 29.69 18.193L36.4334 14.2996Z",
    fill: "url(#paint0_linear_327_1970)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.7078 36.8247C37.843 36.3254 36.7775 36.3254 35.9127 36.8247L21.8976 44.9163C21.0328 45.4156 20.5 46.3384 20.5 47.337V55.3764H54.1205V47.337C54.1205 46.3384 53.5877 45.4156 52.7229 44.9163L38.7078 36.8247Z",
    fill: "url(#paint1_linear_327_1970)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_327_1970",
    x: 19.5683,
    y: 13.1183,
    width: 37.347,
    height: 45.0533,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.931719,
    dy: 0.931719
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.931719
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_327_1970"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_327_1970",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_327_1970",
    x1: 47.3034,
    y1: 13.7617,
    x2: 27.4268,
    y2: 13.7617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90278F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B491FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_327_1970",
    x1: 54.1205,
    y1: 36.4502,
    x2: 20.5,
    y2: 36.4502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90278F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B491FF"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyUs3);
export default __webpack_public_path__ + "static/media/why-us-3.7ba7a59f7b5135d787c7f2639dd26cb8.svg";
export { ForwardRef as ReactComponent };